/**
 * Top-level routing for the GroupPulse web app.
 *
 * Public routes:
 *   /            — landing; redirects authenticated users to /dashboard
 *   /sign-in/*   — Clerk-hosted sign-in
 *   /sign-up/*   — Clerk-hosted sign-up
 *
 * Authenticated routes:
 *   /dashboard   — signed-in landing
 *
 * Authentication is gated by Clerk's <SignedIn> / <SignedOut> components,
 * which read from ClerkProvider context. Unauthenticated visits to
 * /dashboard are redirected to /sign-in.
 */

import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ClientDetail } from './pages/ClientDetail';
import { Clients } from './pages/Clients';
import { ConnectExtension } from './pages/ConnectExtension';
import { Dashboard } from './pages/Dashboard';
import { Landing } from './pages/Landing';
import { Leads } from './pages/Leads';
import { NewClient } from './pages/NewClient';
import { Profile } from './pages/Profile';
import { Settings } from './pages/Settings';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { Team } from './pages/Team';
import { Thanks } from './pages/Thanks';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/thanks" element={<Thanks />} />
      <Route path="/connect-extension" element={<ConnectExtension />} />
      <Route
        path="/dashboard"
        element={
          <>
            <SignedIn>
              <Dashboard />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/leads"
        element={
          <>
            <SignedIn>
              <Leads />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/admin/new-client"
        element={
          <>
            <SignedIn>
              <NewClient />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/admin/clients"
        element={
          <>
            <SignedIn>
              <Clients />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/admin/clients/:id"
        element={
          <>
            <SignedIn>
              <ClientDetail />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/admin/team"
        element={
          <>
            <SignedIn>
              <Team />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/profile"
        element={
          <>
            <SignedIn>
              <Profile />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route
        path="/settings"
        element={
          <>
            <SignedIn>
              <Settings />
            </SignedIn>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
          </>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
